import { DropdownButton, Dropdown } from "react-bootstrap";
import { ucfirst } from "../helpers/String";

export default function PerformanceBreakdownSelector({ value = "", onChange }) {
  const onClick = (report) => {
    if (onChange) {
      onChange(report);
    }
  };

  return (
    <div className="standard-dropdown">
      <div className="standard-dropdown-label">Breakdown by:</div>
      <DropdownButton title={value ? ucfirst(value) : "Select an option"}>
        <Dropdown.Item onClick={() => onClick("")} as="button">
          -
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onClick("domain")} as="button">
          Domain
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onClick("client")} as="button">
          Client
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onClick("poll")} as="button">
          Poll
        </Dropdown.Item>
      </DropdownButton>
    </div>
  );
}
